import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'

interface ImageProps {
  path: string
  alt?: string
  width?: number
  height?: number
  border?: string
}
export const CustomImage = ({
  path,
  alt,
  width,
  height,
  border,
}: PropsWithChildren<ImageProps>) => {
  return (
    <img
      className={classNames('rounded-[4px]', {
        [`${border}`]: border,
      })}
      src={path}
      alt={alt || ''}
      width={width}
      height={height}
      onError={(e) => {
        e.currentTarget.src = ''
      }}
      loading="lazy"
    />
  )
}
